module.exports = __webpack_public_path__ + "static/media/check-icon.9cf7d9a6.svg";